import React from 'react';

import HeaderSecondary from '@components/HeaderSecondary';
import SubHeader from '@components/HealthQuoteResultPage/SubHeader';
import { useQuoteOptionParams } from '@components/Feature/HealthQuote/hook';
import { routeCancerQuotePage } from '@components/HealthQuotePage';

import CancerQuoteList from './CancerQuoteList';
import ComparableCancerQuote from './ComparableCancerQuote';

const CancerQuoteResultPage = () => {
  const params = useQuoteOptionParams();

  return (
    <>
      <HeaderSecondary />
      <SubHeader formLinkTo={routeCancerQuotePage({ path: 'members', ...params })} />
      <CancerQuoteList />
      <ComparableCancerQuote />
    </>
  );
};

export { CancerQuoteResultPage };
